import React from "react";
import ErrorBoundary from "../Components/ErrorBoundary";
import ErrorHandler from "../Components/ErrorHandler";
import ErrorFallback from "../Pages/ErrorFallback";
import AppProvider from "../Providers/AppProvider";
import ToasterProvider from "../Providers/ToasterProvider";
import App from "./App";

export default function Bootstrapper() {
    return (
        <React.StrictMode>
            <ErrorBoundary fallback={props => <ErrorFallback {...props} />}>
                <ToasterProvider>
                    <AppProvider>
                        <App />
                        <ErrorHandler />
                    </AppProvider>
                </ToasterProvider>
            </ErrorBoundary>
        </React.StrictMode>
    )
}